import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from './App';
import "@patternfly/pfe-markdown/dist/pfe-markdown";
import "@patternfly/pfe-health-index/dist/pfe-health-index";
import "@patternfly/pfe-select/dist/pfe-select";
import Env from "./utils/env";

if (Env.getEnvName() === Env.EnvNames.PROD) {
    Sentry.init({
        environment: "production",
        ...(import.meta.env.VITE_SPA_VERSION && {
            release: "spco-001-rhc-certification-workflow@" + import.meta.env.VITE_SPA_VERSION
        }),
        dsn: "https://8ea8c868e00b48aab464b004d3a0d4e6@o59191.ingest.sentry.io/5775440"
    });
}

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);
